
import React, { useRef, useState } from 'react';
import useMounted from '../../hooks/useMounted';
import { get } from '../../helpers/api_helper';
import { GET_SUBSCRIPTION_PLAN } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import PaymentModal from '../../components/PaymentModal';

const UpgradePlan = () => {
    const paymentModalRef = useRef();

    const [ShowLoader, SetShowLoader] = useState(false);
    const [active_plan_info, SetActive_plan_info] = useState(null);
    const [planInfo, SetPlanInfo] = useState([]);

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({
        transactionId: '',
        orderId: 0,
        totalEmployees: 10,
        subscriptionType: 'Monthly',
        monthlyPrice: 0,
        annualPrice: 0,
        totalAmount: 0
    });



    useMounted(() => {
        async function get_detaile() {
            getHomeDate();
        }
        get_detaile();
    }, [])


    const getHomeDate = async () => {
        SetShowLoader(true);
        var res_data = await get(GET_SUBSCRIPTION_PLAN);
        if (res_data.status) {
            SetActive_plan_info(res_data.data.active_plan_info);
            SetPlanInfo(res_data.data.plan_info);

            form_inputs.monthlyPrice = res_data.data.plan_info.monthlyPrice;
            form_inputs.annualPrice = res_data.data.plan_info.annualPrice;
            setInputs({ ...form_inputs });

        } else {
            toast.error(res_data.message);
        }
        SetShowLoader(false);
    }

    const openModel = async () => {
        SetButtonDisabled(true);
        paymentModalRef.current.openPaymentModel(planInfo.planId, form_inputs.subscriptionType, form_inputs.totalEmployees,0);
    }
    const payModel = async () => {

        SetButtonDisabled(true);
        paymentModalRef.current.openPaymentModel(planInfo.planId, active_plan_info.subscriptionType, form_inputs.totalEmployees, active_plan_info.subscriptionId);
    }

    // input text change handler
    const handleInputChange = (event) => {
        if (event.target.name === 'totalEmployees') {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
            const percent = ((event.target.value - 10) / (parseInt(planInfo.totalEmployees) - parseInt(10))) * 100;
            event.target.style.setProperty('--percent', `${percent}%`);

        } else if (event.target.name === 'subscriptionType') {
            setInputs(inputs => ({ ...inputs, [event.target.name]: (event.target.checked) ? 'Yearly' : 'Monthly' }));
        } else {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        }
    }

    const totalcost = () => {
        var totalAmount = 0
        if (form_inputs.subscriptionType === 'Monthly') {
            totalAmount = form_inputs.totalEmployees * form_inputs.monthlyPrice;
        } else {
            totalAmount = ((form_inputs.totalEmployees * form_inputs.annualPrice) * 12);
        }
        return totalAmount.toFixed(2);
    }

    const totalcostAddEmployees = () => {
        var totalAmount = 0
        if (active_plan_info.subscriptionType === 'Monthly') {
            totalAmount = ((form_inputs.totalEmployees * active_plan_info.monthlyPrice * active_plan_info.differentDays) / active_plan_info.totalDays);
        } else {
            totalAmount = ((form_inputs.totalEmployees * (active_plan_info.annualPrice * 12) * active_plan_info.differentDays) / active_plan_info.totalDays);
        }
        return totalAmount.toFixed(2);
    }

    const generateSteps = (max) => {
        let labels = '<div class="range-labels">\n';
        labels += `<span>10</span>\n`;
        for (let i = 100; i <= max; i += 100) {
            labels += `<span>${i}</span>\n`;
        }
        labels += `</div>`;
        return labels;
    }

    return (
        <>
            {ShowLoader && <Loader />}

            <div className='row'>
                <div className="col-md-12 col-lg-2 col-xl-3 mb-4"></div>
                {(active_plan_info && active_plan_info.plan_status && active_plan_info.code !== 'FREE') &&
                    <div className="col-md-12 col-lg-8 col-xl-6 mb-4">
                        <div className="card card-border-shadow-primary p-sm-5 p-3">
                            <div className='text-center mb-4'>
                                <h4>Add More Employees</h4>
                                <p className='mb-0'>Pro billing for remaining subscription period</p>
                            </div>
                            <div className='card price-bg-color mb-4'>
                                <div className='card-body'>
                                    <div className='row mb-3'>
                                        <div className='col-9'>
                                            <h5 className='text-white'>Current Monthly Plan</h5>
                                        </div>
                                        <div className='col-3 text-right'>
                                            <span className='badge rounded-pill bg-warning text-dark mb-3'>Active</span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12 col-sm-4 text-center'>
                                            <h3 className='mb-1'>{active_plan_info.totalEmployees}</h3>
                                            <p className='mb-3'>Current Employees</p>
                                        </div>
                                        <div className='col-12 col-sm-4 text-center'>
                                            <h3 className='mb-1'>{active_plan_info.subscriptionType}</h3>
                                            <p className='mb-3'>Subscription</p>
                                        </div>
                                        <div className='col-12 col-sm-4 text-center'>
                                            <h3 className='mb-1'>{active_plan_info.totalDays - active_plan_info.differentDays}</h3>
                                            <p className='mb-3'>Days Elapsed</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card mb-4' style={{ "backgroundColor": "#f8f9fa" }}>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <h5 className='mb-2'>Add New Employees</h5>
                                            <label className='form-label text-capitalize'>Number of Employees to Add</label>
                                            <input name="totalEmployees" value={form_inputs.totalEmployees} onChange={handleInputChange} maxLength={3} className="form-control mb-3" type="text" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card mb-4 shadow-none'>
                                <div className='card-body border rounded'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <h5 className='mb-4'>Cost Breakdown</h5>
                                            <div className='row'>
                                                <div className='col-8'><small>New Employees</small></div>
                                                <div className='col-4 text-right'><small>{form_inputs.totalEmployees || 0}</small></div>
                                                <div className='col-12'>
                                                    <hr className='mt-2 mb-2' />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-8'><small>Rate per Employee (Monthly)</small></div>
                                                <div className='col-4 text-right'>
                                                    <small>₹{(active_plan_info.subscriptionType === 'Monthly') ? active_plan_info.monthlyPrice.toFixed(2) : active_plan_info.annualPrice.toFixed(2)}</small>
                                                </div>
                                                <div className='col-12'>
                                                    <hr className='mt-2 mb-2' />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-8'><small> Remaining Days in Cycle</small></div>
                                                <div className='col-4 text-right'><small>{active_plan_info.differentDays} days</small></div>
                                                <div className='col-12'>
                                                    <hr className='mt-2 mb-2' />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-8'><b>Total Amount</b></div>
                                                <div className='col-4 text-right'><b>₹{totalcostAddEmployees()}</b></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button onClick={() => { payModel() }} disabled={ButtonDisabled || !form_inputs.totalEmployees} className='btn w-100 btn-primary mb-4'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Proceed to Payment</button>
                            <div className="rounded p-3" style={{ "background":"#e9ecef"}}>
                                <b>Calculation Formula:</b><br/>
                                {active_plan_info.subscriptionType === 'Monthly' && <small> Cost = (New Employees × Monthly Rate × Remaining Days) ÷ Total Days in Month </small>}
                                {active_plan_info.subscriptionType !== 'Monthly' && <small> Cost = (New Employees × Yearly Rate × Remaining Days) ÷ 365 </small>}
                            </div>
                        </div>
                    </div>}

                {(!active_plan_info || !active_plan_info.plan_status || active_plan_info.code === 'FREE') &&
                    <div className="col-md-12 col-lg-8 col-xl-6 mb-4 price-plan">
                        <div className="card card-border-shadow-primary p-sm-5 p-3 pt-5 pb-5">
                            <div className="card-body d-flex align-items-center justify-content-between pt-0 pb-4" style={{ "margin": "0px auto" }}>
                                <div class="d-flex align-items-center gap-2">
                                    <label class="form-check-label me-1" for="flexSwitchCheckChecked">Monthly</label>
                                    <label class="toggle-switch form-check form-switch">
                                        <input class="form-check-input" name='subscriptionType' onChange={handleInputChange} type="checkbox" id="flexSwitchCheckChecked" checked={(form_inputs.subscriptionType === 'Yearly') ? true : false} />
                                    </label>
                                    <label class="form-check-label" for="flexSwitchCheckChecked">Yearly<span class="ms-2 badge rounded-pill bg-success text-capitalize">Save ₹{form_inputs.monthlyPrice - form_inputs.annualPrice} / employee</span></label>
                                </div>
                            </div>
                            <div className='text-center mb-4'>
                                <h5>How many employees do you have?</h5>
                            </div>
                            <div className='text-center mb-4'>
                                <h1 className='mb-0 text-primary'>{form_inputs.totalEmployees}</h1>
                                <p>Employees</p>
                            </div>
                            <div className='mb-5'>
                                <input type="range" name="totalEmployees" class="form-range1 custom-range" min="10" max={planInfo.totalEmployees} step="5" value={form_inputs.totalEmployees} onChange={handleInputChange} />
                                <div dangerouslySetInnerHTML={{ __html: generateSteps(planInfo.totalEmployees) }} />
                            </div>
                            <div className='card price-bg-color mb-4'>
                                <div className='card-body'>
                                    <div className='row text-center'>
                                        <div className='col-6'>
                                            <p className='mb-2'>Per Employee</p>
                                            {form_inputs.subscriptionType === 'Yearly' &&
                                                <h3><span className='rupee-icon'>₹</span>{form_inputs.annualPrice.toFixed(2)}<span className='smmal_text'>(Per Month)</span></h3>
                                            }
                                            {form_inputs.subscriptionType === 'Monthly' &&
                                                <h3><span className='rupee-icon'>₹</span>{form_inputs.monthlyPrice.toFixed(2)}<span className='smmal_text'>(Per Month)</span></h3>
                                            }
                                        </div>
                                        <div className='col-6'>
                                            <p className='mb-2'>Number of Employees</p>
                                            <h3>{form_inputs.totalEmployees}</h3>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row text-center'>
                                        <div className='col-12'>
                                            <p className='mb-2 text-capitalize'>Total {form_inputs.subscriptionType} Cost</p>
                                            <h3> <span className='rupee-icon'>₹</span>{totalcost()}<span className='smmal_text'>/{(form_inputs.subscriptionType === 'Yearly') ? 'Year' : 'Month'}</span> </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div >
                                <button onClick={() => { openModel() }} disabled={ButtonDisabled} className='btn w-100 btn-primary'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Proceed to Payment</button>
                            </div>
                        </div>
                    </div>
                }

                {/* <div className="col-sm-12 col-lg-3 mb-4"></div> */}
            </div>

            <PaymentModal ref={paymentModalRef} call_back={() => { SetButtonDisabled(false) }} />
        </>
    );
}

export default UpgradePlan;